import $ from 'jquery';

// modified from https://gist.github.com/gordonbrander/2230317
const newId = () => {
  return `AutoId-${Math.random().toString(36).substr(2, 9)}`;
};

const generateId = () => {
  let uniqueId;

  while (true) {
    uniqueId = newId();

    if ($(`#${uniqueId}`).length === 0) {
      break;
    }
  } 

  return uniqueId;
};

export {
  generateId,
};